export const lifecycleStates = [
  'draft',
  'dirty',
  'ready',
  'published',
] as const;

export type LifecycleState = (typeof lifecycleStates)[number];
export type LifecycleStateWithFailed = LifecycleState | 'failed';
export const lifecycleLabels: Record<LifecycleStateWithFailed, string> = {
  draft: 'Draft',
  dirty: 'Dirty',
  ready: 'Ready',
  published: 'Published',
  failed: 'Failed',
};

export function isLifecycleState(value: string): value is LifecycleState {
  return (lifecycleStates as readonly string[]).includes(value);
}
